/** `/help?doc=` as the assistant cites it: a docs path with literal slashes (REQUESTS #74), nothing else. */
export function helpSearch(search: Record<string, unknown>): { doc?: string } {
  const doc = search.doc;
  if (typeof doc !== "string" || doc.length > 300 || !/^[A-Za-z0-9_./-]+$/.test(doc) || doc.includes("..")) return {};
  return { doc };
}
